import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import useColors from "api/hooks/useColors";

const formatEnvironmentName = (envId) => {
  if (!envId) return envId;

  let formatted = envId.replace(/^https?:\/\//, "");
  formatted = formatted.replace(/\.breezesec\.com$/, "");

  return formatted;
};

const EntitiesByEnvironmentWidget = ({ summary, isLoading }) => {
  const colors = useColors();

  const entitiesByEnv = summary?.entities_by_env || {};
  const chartData = Object.entries(entitiesByEnv)
    .map(([envId, count]) => ({
      envId: formatEnvironmentName(envId),
      count,
    }))
    .sort((a, b) => b.count - a.count);

  const xAxisData = chartData.map((item) => item.envId);
  const seriesData = chartData.map((item) => item.count);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!chartData || chartData.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
      }}
    >
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: xAxisData,
            tickLabelStyle: {
              angle: -45,
              textAnchor: "end",
              fontSize: 10,
            },
          },
        ]}
        series={[
          {
            data: seriesData,
            label: "Entities",
            color: colors.secondary_main,
          },
        ]}
        height={300}
        margin={{ bottom: 80, left: 50, right: 20, top: 20 }}
      />
    </Box>
  );
};

export default EntitiesByEnvironmentWidget;
